
import { Box, ListItem, ListItemIcon, ListItemText, Stack, useTheme } from "@mui/material";
import { Square } from "@mui/icons-material";
import { IObjectAttributeValue } from "../../../services/attribute-data-service/Models";

export type AttributeSchemaUsageListItemProps = {
    item: IObjectAttributeValue,
};

export function AttributeSchemaUsageListItem({
    item,
}: AttributeSchemaUsageListItemProps) {

    const theme = useTheme();

    return (
        <ListItem disablePadding >
            <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                <Square fontSize="inherit"/>
            </ListItemIcon>
            <ListItemText 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                primary={

                    <Stack
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: '1 1 auto'
                        }}>
                        <Box
                            sx={{
                                flexBasis: '50%',
                                maxWidth: 300
                            }}>
                            {item.object.displayText}
                        </Box>
                        <Box
                            sx={{
                                flexBasis: '50%',
                                marginLeft: 3
                            }}>
                            {item.value}
                        </Box>
                    </Stack>
                } 
            
                slotProps={{
                    primary: {
                        component: 'div',
                        sx: {
                            fontSize: '.9rem',
                            display: 'flex',
                            color: theme.palette.grey[600]
                        }
                    }
                }} 
            />
        </ListItem>
    );
}
